import React from "react";
import { Link, useParams } from "react-router-dom";
import "../../../assets/css/FeaturedSection.css";

const commitments = [
  {
    number: "01",
    icon: "fa-road",
    title: "Modern Road Infrastructure",
    description:
      "We are committed to developing and upgrading Nigeria’s road networks and highways to improve connectivity, facilitate transportation, and support economic growth across the nation",
  },
  {
    number: "02",
    icon: "fa-bridge",
    title: "Bridge Development and Maintenance",
    description:
      "We promote the construction, rehabilitation, and maintenance of bridges and critical highway structures to ensure safer journeys, reliable transport links, and lasting infrastructure.",
  },
  {
    number: "03",
    icon: "fa-helmet-safety",
    title: "Quality Construction and Project Delivery",
    description:
      "Through effective engineering, quality assurance, and strategic project supervision, we work to deliver durable road infrastructure that meets national standards and provides long-term value for public investment.",
  },
  {
    number: "04",
    icon: "fa-shield-halved",
    title: "Transparency and Public Accountability",
    description:
      "We uphold professionalism, transparency, and accountability in road construction and maintenance projects, promoting responsible resource management, effective service delivery, and public confidence",
  },
];

function FeaturedSection() {
  const { section, id } = useParams();

  return (
    <section id="featured-services" className="fmw-commitments-section">
      <div className="container">
        <header className="fmw-commitments-heading">
          <span className="fmw-commitments-kicker">
            OUR MANDATE · OUR VALUES
          </span>
          <h2>
            Our Commitment <span>to Excellence</span>
          </h2>
          {/* <p>
            Building better homes, stronger communities and sustainable cities
            through responsible public service.
          </p> */}
        </header>

        <div className="fmw-commitments-grid">
          {commitments.map((item) => (
            <article className="fmw-commitment-card" key={item.number}>
              <div className="fmw-commitment-card-top">
                <span className="fmw-commitment-number">{item.number}</span>
                <span className="fmw-commitment-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <div className="fmw-commitment-card-footer">
                <span>FEDERAL MINISTRY OF WORKS</span>
                <span className="fmw-commitment-accent" aria-hidden="true">
                  ↗
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedSection;
